import React, { useEffect, useRef, useState } from "react";
import COPY from "../../assets/copy.svg";

const UserMessage = ({ message }) => {
  const [copied, setCopied] = useState(false);
  const copyTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
    };
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(message || "").then(() => {
      setCopied(true);
      if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
      copyTimeoutRef.current = setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div className="group relative msg user-msg max-w-[85%] flex-start bg-[#D1E9FF] border-[1px] border-[#F2F9FF] p-[0.4rem] md:p-[0.6rem] px-2 md:px-4 rounded-[4px]">
      <p className="text-[#424242] text-sm whitespace-pre-line">{message}</p>

    <img
      src={COPY}
      alt="copy"
      title="Copy"
      onClick={handleCopy}
      className="h-[18px] p-[2px] cursor-pointer absolute left-[-20px] top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity"
    />

      {copied && (
      // Positioned below the copy icon (not above it, like before) — the
      // first message in a conversation sits right under the hero section
      // with no room above to render into, so an above-positioned tooltip
      // was getting clipped/hidden for that message specifically.
      <div className="absolute left-[-28px] top-[calc(50%+14px)] z-10 flex flex-col items-center">
        <div className="bg-[#2f2f2f] text-white text-[12px] px-2 py-[3px] rounded shadow-md whitespace-nowrap relative">
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-[6px] border-l-transparent border-r-transparent border-b-[#2f2f2f]" />
          Copied!
        </div>
      </div>
      )}
    </div>
  );
};

export default UserMessage;
